import { Team__Nogaleras } from "../teams/Nogaleras";
import { Team__Potras } from "../teams/Potras";
import { Team__Pythons } from "../teams/Pythons";
import { Team__Raptors } from "../teams/Raptors";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Nogaleras = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 27,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 16,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 26,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 12,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada1 = {
  jornadaPosition: 1,
  matches: [
    {
      team1: Raptors,
      team2: Nogaleras,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2025-07-28",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Potras,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2025-07-28",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
